export default __webpack_public_path__ + "static/media/closet5-before1-768w.26b5f174.webp";